module.exports = __webpack_public_path__ + "assets/7448fbc8ef856c1d005f1750b3d08814.png";